import { useRegisterActions } from "kbar";

import type { CommandAction } from "src/components/commandbar/types";

// Types registrations as `CommandAction`, so the palette's extra fields pass kbar's narrower `Action`.
export const useRegisterCommandActions = (
  actions: CommandAction[],
  dependencies: unknown[],
) => useRegisterActions(actions, dependencies);
